module.exports = __webpack_public_path__ + "img/coupons.cbfcc977.svg";